<script>
import BaseTemplate from './../BaseTemplate'

export default {
   extends: BaseTemplate,
   methods: {
      getImageStyle(zone) {
         return ' left: ' + zone.assetX + 'px; top: ' + zone.assetY + 'px; width: ' + zone.assetW * zone.scaleX + 'px;';
      }
   }
}

</script>

<style lang="scss" scoped>
   .template-wrapper {
      transform-origin: top left;
   }

   .scene-btns-wrapper {
      display: flex;
      position: absolute;
      max-width: 100%;
      margin-top: 24px;
   }

   .template {
      position: relative;
      z-index: 1;
   }

   .video-box {
      width: 100%;
      height: 315px;

      // background-image: url('./assets/grid-bg.svg');
   }

   .scoreboard-zone {
      display: flex;
      align-items: center;
      justify-content: center;
   }

   .scoreboard-text {
      text-transform: uppercase;
      font-size: 16px;
      font-weight: bold;
   }

   .blue-box {
      background: #4ba5da;
      width: 155px;
      height: 85px;
      position: absolute;
      bottom: 0;
      left: 202px;

      &.football {
         left: 158px;
         width: 243px;
         background: black;
      }
   }

   .black-bg {
      height: 85px;
      z-index: 0;
      width: 100%;
      background: black;
      position: absolute;
      bottom: 0;

      &.blue {
         background-color: rgb(0,16,61);
      }
   }
</style>